"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hamburger = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hamburgerModule = _interopRequireDefault(require("./hamburger.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Hamburger = function Hamburger(_ref) {
  var isActive = _ref.isActive,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height;
  var wrapperclassName = (0, _react.useMemo)(function () {
    return [_hamburgerModule.default.wrapper, isActive ? _hamburgerModule.default.active : ""].join(" ");
  }, [isActive]);
  var wrapperStyles = (0, _react.useMemo)(function () {
    return {
      width: width,
      height: height
    };
  }, [width, height]);
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 50 50",
    className: wrapperclassName,
    style: wrapperStyles
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: _hamburgerModule.default.lines
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "5",
    x2: "45",
    y1: "10",
    y2: "10",
    className: _hamburgerModule.default.line1
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "5",
    x2: "45",
    y1: "25",
    y2: "25",
    className: _hamburgerModule.default.line2
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "5",
    x2: "45",
    y1: "40",
    y2: "40",
    className: _hamburgerModule.default.line3
  })));
};

exports.Hamburger = Hamburger;
Hamburger.defaultProps = {
  isActive: false,
  height: "2.5rem",
  width: "auto"
};
Hamburger.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  isActive: _propTypes.default.bool
};